/**
 * Offset a sticky page element has to sit at so it clears the app bar.
 *
 * Vuetify's `--v-layout-top` is not usable for this. An app bar with
 * `scroll-behavior="hide"` keeps its extension (the tabs row) on screen but
 * marks the layout item inactive, so the variable reports 0 while the
 * extension is still occupying the top of the viewport. Measuring the bar's
 * own bottom edge is the only signal that stays true in every scroll state.
 *
 * @param {DOMRect|null|undefined} appBarRect bounding rect of the app bar, if present
 * @returns {number|null} offset in px, or null when there is no app bar to clear
 */
export const resolveStickyTop = (appBarRect) => {
  if (!appBarRect) return null

  // The bar is translated off-screen rather than unmounted, so its bottom goes
  // negative once fully hidden -- clamp so the element pins to the viewport top.
  return Math.max(0, Math.round(appBarRect.bottom))
}
